import { render, staticRenderFns } from "./CoverPanel.vue?vue&type=template&id=3d583ff6&scoped=true&"
import script from "./CoverPanel.vue?vue&type=script&lang=js&"
export * from "./CoverPanel.vue?vue&type=script&lang=js&"
import style0 from "./CoverPanel.vue?vue&type=style&index=0&id=3d583ff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d583ff6",
  null
  
)

export default component.exports